import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {LoggerService} from '../logger/LoggerService';
import {EnvironmentType} from '../modules/common/enums/environment-type';
import {AuthenticationService} from '../modules/common/services/authentication/authentication.service';
import {HttpHeadersService} from '../modules/common/services/http-headers.service';
import {TokenService} from "../modules/common/services/token.service";
import {Environment} from "../environment/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private logger: LoggerService, private router: Router, private authenticationService: AuthenticationService,
              private tokenService: TokenService, private headersService: HttpHeadersService, private readonly environment: Environment) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    if (this.authenticationService.doesTokenExist()) {
      req = this.ifOnLocalCloneRequestWithTokensInHeaders(req);
      return next.handle(req).pipe(
          catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            switch ((<HttpErrorResponse>error).status) {
              case 401:
                window.location.href = this.environment.accountSiteUrl + 'login?application=Building&redirectUrl=' + window.location.href;
                return of(null);
              case 403:
                if(this.tokenService.getLicenseAgreed())
                  this.router.navigateByUrl('/forbidden-page', { skipLocationChange: true });
                else {
                  window.location.href = this.environment.accountSiteUrl;
                }
                return of(null);
              default:
                const showModal = !this.headersService.hasNoModalHeader(req);
                const logError = !this.headersService.hasNoLogHeader(req);
                if (logError) {
                  this.logger.httpRequestError(error.status, req.method, req.urlWithParams, JSON.stringify(req.body), showModal);
                }
                return throwError(error);
            }
          } else {
            return next.handle(req);
          }
        })
      );
    } else {
      return next.handle(req);
    }
  }

  private ifOnLocalCloneRequestWithTokensInHeaders(req: HttpRequest<any>): HttpRequest<any> {
    if (this.environment.environmentName === EnvironmentType.LOCAL) {
      return req.clone({
        setHeaders: {
          'jwt': this.authenticationService.getToken(),
          'refreshtoken': this.authenticationService.getRefreshToken(),
        }
      });
    } else {
      return req;
    }
  }
}
